import { CommonModule } from '@angular/common';
import { Component, ElementRef, EventEmitter, Input, Output, TemplateRef, ViewChild } from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { ApiCallsService } from '../../shared/services/network/api-calls.service';
import { UserService } from '../../shared/services/user.service';
import { api } from '../../utils/endpoints';
import { fileDirectories } from '../../utils/view-settings';

@Component({
  selector: 'app-home-banner',
  imports: [CommonModule],
  templateUrl: './home-banner.component.html',
  styleUrl: './home-banner.component.scss',
})
export class HomeBannerComponent {
  userLoggedIn = false;
  @Input() bannerList: any;
  isBannerLoaded: boolean = false;
  readonly heroBackground = 'assets/images/home/homebanner.jpg';
  readonly heroVideoSource = 'assets/videos/xdge-home-video-v2.mp4';
  readonly heroVideoPoster = 'assets/images/img_water_skiing.png';
  readonly heroVideoTagline = 'Follow your fears';
  private videoModalRef?: NgbModalRef;

  @ViewChild('heroVideoModal') heroVideoModalRef?: TemplateRef<any>;
  @ViewChild('heroVideo') heroVideoRef?: ElementRef<HTMLVideoElement>;
  private readonly fallbackLineOne = 'Track your edge';
  private readonly fallbackLineTwo = 'Prove your level';
  private readonly fallbackDescription =
    'XDGE is a platform and collective built for extreme sport athletes across Air, Earth, Water, and Ice. We track progression, recognize risk, and connect athletes through earned experience. No shortcuts. No buying in. No pretending.';
  @Output() scrollToSection = new EventEmitter<void>();

  fileDirectoriesPath: any = fileDirectories.profile;
  constructor(
    private _apiService: ApiCallsService,
    private _userService: UserService,
    private _modalService: NgbModal,
  ) {
    // this._apiService.loader(true);
    this._userService
      .getUser()
      .pipe()
      .subscribe((user) => {
        if (user) {
          this.userLoggedIn = true;
        } else this.userLoggedIn = false;
        // this._getBannerList();
      });
  }

  private _getBannerList(): void {
    // this._apiService.loader(true);
    this._apiService.get(api._banner, {}).subscribe({
      next: (res: any) => {
        this.bannerList = res?.data?.rows;
        this.isBannerLoaded = true;
      },
      error: (error: any) => console.log(error),
    });
  }

  triggerScroll() {
    this.scrollToSection.emit();
  }

  get primaryBanner(): any {
    return this.bannerList?.length ? this.bannerList[0] : null;
  }

  get heroLineOne(): string {
    return this.primaryBanner?.titleLineOne || this.primaryBanner?.title || this.fallbackLineOne;
  }

  get heroLineTwo(): string {
    return this.primaryBanner?.titleLineTwo || this.primaryBanner?.subTitle || this.fallbackLineTwo;
  }

  get heroDescription(): string {
    return this.primaryBanner?.description || this.fallbackDescription;
  }

  get heroVideoThumbnail(): string {
    return this.primaryBanner?.image ? this.fileDirectoriesPath + this.primaryBanner.image : this.heroVideoPoster;
  }

  openHeroVideo(): void {
    if (!this.heroVideoModalRef) {
      return;
    }

    this.videoModalRef = this._modalService.open(this.heroVideoModalRef, {
      size: 'xl',
      fullscreen: 'md-down',
      centered: true,
      scrollable: false,
      windowClass: 'hero-video-modal-window',
      backdrop: 'static',
      keyboard: true,
    });

    const resetVideo = () => this.resetHeroVideo();
    this.videoModalRef.closed.subscribe(resetVideo);
    this.videoModalRef.dismissed.subscribe(resetVideo);

    setTimeout(() => this.playHeroVideo(), 0);
  }

  closeHeroVideo(): void {
    this.videoModalRef?.close();
  }

  private playHeroVideo(): void {
    const videoEl = this.heroVideoRef?.nativeElement;
    if (videoEl) {
      videoEl.currentTime = 0;
      videoEl.play().catch(() => void 0);
    }
  }

  private resetHeroVideo(): void {
    const videoEl = this.heroVideoRef?.nativeElement;
    if (videoEl) {
      videoEl.pause();
      videoEl.currentTime = 0;
    }
  }
}
